<template>
  <div>
    <DetailPageLayout
      :breadcrumbItems="breadcrumbItems"
      :buttonItems="buttonItems"
    >
      <template #top>
        <BaseTabGroup
          ref="tab-group"
          :inputModel="ProductPattern"
          :inputComponents="inputComponents"
          @clear="clear(obj)"
        ></BaseTabGroup>
      </template>
      <template #bottom>
        <div class="data-group-role">
          <div id="BaseView">
            <section data-class="work-list-table">
              <div>
                <BaseButton
                  class="edit-button"
                  variant="success"
                  :columnInfo="detailCtrlInfo.add"
                  icon="plus-circle"
                  @click="openSubModal(obj, 'product-modal')"
                />
                <BaseButton
                  class="edit-button"
                  variant="success"
                  :disabled="!isSelected"
                  :columnInfo="detailCtrlInfo.delete"
                  icon="minus-circle"
                  @click="remove(obj)"
                />
              </div>
              <!-- テーブル -->
              <BaseTable
                select-mode="range"
                ref="table"
                :fields="fields"
                :items="tableItems"
                @row-selected="onRowSelected"
                @row-clicked="onRowClicked"
              />
            </section>
          </div>
        </div>
      </template>
    </DetailPageLayout>
    <!-- 荷姿参照モーダル-->
    <ProductModal
      id="product-modal"
      type="entry"
      :useUnset="false"
      @after-close-set="afterCloseSetItem"
    />
    <!-- 情報モーダル -->
    <InfoModal
      id="productPattern-detail-info-modal"
      :columnInfos="messageInfo"
      :message="infoMessage"
      @after-close="back(obj)"
    />
    <!-- 登録モーダル -->
    <ConfirmModal
      id="register-modal"
      :columnInfos="messageInfo"
      :message="registerMessage"
      @confirm="register(obj)"
    />
  </div>
</template>

<script>
import ProductPatternInfo from './ProductPatternInfo'
import { getListOptions, openSubModal } from '@/common/Common.js'
import { getBreadcrumbItems, back } from '@/common/screen-common.js'
import {
  init,
  goRegister,
  register,
  remove,
  clear,
} from '@/master/productPattern/ProductPatternDetail.js'
import _ from 'lodash'

export default {
  name: 'productPatternDetail',

  components: {
    ProductModal: () => import('@/master/product/ProductModal.vue'),
  },

  props: {
    beforeScreenRouteInfo: {
      type: Object,
    },
    productPatternId: {
      type: Number,
      default: -1,
    },
    screenKbn: {
      type: Number,
    },
  },

  data() {
    return {
      tableItems: [],
      selectedItem: [],
      ProductPattern: new ProductPatternInfo(),
      obj: this,
      registerMessage: null,
      detailScreenKbn: 0,
      detailRowIndex: -1,
      selectedProductPatternDetail: [],
      oriData: new ProductPatternInfo(),
    }
  },

  created() {
    init(this)
  },

  computed: {
    detailCtrlInfo() {
      return this.$store.getters['init/getScreens'](
        this.SCREEN_ID.PRODUCT_PATTERN_DETAIL
      )('detail_ctrl_info')
    },
    detailInfo() {
      return this.$store.getters['init/getScreens'](
        this.SCREEN_ID.PRODUCT_PATTERN_DETAIL
      )('detail_info')
    },
    messageInfo() {
      return this.$store.getters['init/getScreens'](this.SCREEN_ID.COMMON)(
        'message'
      )
    },
    breadcrumbItems() {
      return getBreadcrumbItems(
        this.beforeScreenRouteInfo,
        this.SCREEN_ID.PRODUCT_PATTERN_DETAIL
      )
    },
    /**
     * ボタン情報リスト.
     * @return {Array}
     */
    buttonItems() {
      return [
        // ボタングループ#1
        [
          // 登録ボタン
          {
            variant: 'success',
            icon: 'edit',
            columnInfo: this.detailCtrlInfo.register,
            onClickCallback: () => {
              goRegister(this)
            },
          },
          // クリアボタン
          {
            variant: 'success',
            icon: 'times-circle',
            columnInfo: this.detailCtrlInfo.clear,
            onClickCallback: () => {
              clear(this)
            },
          },
          // 戻るボタン
          {
            variant: 'success',
            icon: 'times-circle',
            columnInfo: this.detailCtrlInfo.back,
            onClickCallback: () => {
              back(this)
            },
          },
        ],
        // ボタングループ#2
        [],
      ]
    },
    inputComponents() {
      return [
        {
          // 荷姿パターンタブ
          label: this.detailInfo.tab1.label,
          inputComponents: [
            {
              // 荷姿パターンID
              type: 'text',
              id: 'productPatternId',
              columnInfo: this.detailInfo.product_pattern_id,
            },
            {
              // ブロック外公開フラグ
              type: 'select',
              id: 'publicFlg',
              columnInfo: this.detailInfo.public_flg,
              options: getListOptions(this.MASTER_CODE.PUBLIC_FLG),
              rules: [this.INPUT_TYPE_CHECK.REQUIRED],
              onChangeCallback: () => {},
            },
            {
              // 荷姿パターン名
              type: 'text',
              id: 'productPatternName',
              columnInfo: this.detailInfo.product_pattern_name,
              maxLength: 50,
              rules: [this.INPUT_TYPE_CHECK.REQUIRED],
            },
            {
              // 荷姿パターンキー情報
              type: 'text',
              id: 'productPatternKey',
              columnInfo: this.detailInfo.product_pattern_key,
              maxLength: 100,
              rules: [this.INPUT_TYPE_CHECK.REQUIRED],
            },
            {
              // 基準荷姿区分
              type: 'select',
              id: 'standardKind',
              columnInfo: this.detailInfo.standard_kind,
              rules: [this.INPUT_TYPE_CHECK.REQUIRED],
              options: getListOptions(this.MASTER_CODE.STANDARD_KIND),
              onChangeCallback: () => {},
            },
            {
              // 商品モデル
              type: 'text',
              id: 'productModel',
              columnInfo: this.detailInfo.product_model,
              maxLength: 30,
              rules: [
                this.INPUT_TYPE_CHECK.REQUIRED,
                this.INPUT_TYPE_CHECK.ALPHANUMERIC_CODE,
              ],
            },
            {
              // 型
              type: 'text',
              id: 'productType',
              columnInfo: this.detailInfo.product_type,
              maxLength: 30,
              rules: [this.INPUT_TYPE_CHECK.ALPHANUMERIC_CODE],
            },
            {
              // カスタム
              type: 'text',
              id: 'customizeName',
              columnInfo: this.detailInfo.customize_name,
              maxLength: 30,
              rules: [this.INPUT_TYPE_CHECK.ALPHANUMERIC_CODE],
            },
            {
              // 海外向け対象
              type: 'select',
              id: 'forOverseas',
              columnInfo: this.detailInfo.for_overseas,
              rules: [this.INPUT_TYPE_CHECK.REQUIRED],
              options: getListOptions(this.MASTER_CODE.FOR_OVERSEAS),
              onChangeCallback: () => {},
            },
            {
              // 部署予備1
              type: 'text',
              id: 'reserve01',
              columnInfo: this.detailInfo.reserve01,
            },
            {
              // 部署予備2
              type: 'text',
              id: 'reserve02',
              columnInfo: this.detailInfo.reserve02,
            },
            {
              // 部署予備3
              type: 'text',
              id: 'reserve03',
              columnInfo: this.detailInfo.reserve03,
            },
            {
              // 部署予備4
              type: 'text',
              id: 'reserve04',
              columnInfo: this.detailInfo.reserve04,
            },
            {
              // 部署予備5
              type: 'text',
              id: 'reserve05',
              columnInfo: this.detailInfo.reserve05,
            },
            {
              // 部署予備6
              type: 'text',
              id: 'reserve06',
              columnInfo: this.detailInfo.reserve06,
            },
            {
              // 部署予備7
              type: 'text',
              id: 'reserve07',
              columnInfo: this.detailInfo.reserve07,
            },
            {
              // 部署予備8
              type: 'text',
              id: 'reserve08',
              columnInfo: this.detailInfo.reserve08,
            },
            {
              // 部署予備9
              type: 'text',
              id: 'reserve09',
              columnInfo: this.detailInfo.reserve09,
            },
            {
              // 部署予備10
              type: 'text',
              id: 'reserve10',
              columnInfo: this.detailInfo.reserve10,
            },
            {
              // 削除済み区分
              type: 'select',
              id: 'deleted',
              columnInfo: this.detailInfo.deleted,
              options: getListOptions(this.MASTER_CODE.DELETED),
              onChangeCallback: () => {},
            },
            {
              // 登録日時
              type: 'text',
              id: 'registrationTimeDisplay',
              columnInfo: this.detailInfo.registration_time_display,
            },
            {
              // 登録ユーザ
              type: 'text',
              id: 'registrationUser',
              columnInfo: this.detailInfo.registration_user,
            },
            {
              // 更新日時
              type: 'text',
              id: 'updateTimeDisplay',
              columnInfo: this.detailInfo.update_time_display,
            },
            {
              // 更新ユーザ
              type: 'text',
              id: 'updateUser',
              columnInfo: this.detailInfo.update_user,
            },
            {
              // バージョン
              type: 'text',
              id: 'version',
              columnInfo: this.detailInfo.version,
            },
            {
              // トリガ更新日時
              type: 'text',
              id: 'updateByTrigger',
              columnInfo: this.detailInfo.update_by_trigger,
            },
          ],
        },
      ]
    },
    /**
     * テーブル列定義リスト.
     * @return {Array}
     */
    fields() {
      return this.$store.getters['init/getFields'](
        this.SCREEN_ID.PRODUCT_PATTERN_DETAIL
      )(this.DOMAIN_NAME.FIELDS)
    },
    /**
     * 情報メッセージ.
     * @return {String}
     */
    infoMessage() {
      return this.$store.getters['init/getMessage'](
        'YZ00MG995I',
        this.detailCtrlInfo.register.label
      )
    },
    /**
     * 単数選択しているか.
     * @return {Boolean}
     */
    isSelected() {
      return this.selectedItem.length > 0
    },
  },

  methods: {
    getListOptions,
    openSubModal,
    register,
    back,
    clear,
    remove,

    /**
     * 荷姿マスタから取得データ設定
     */
    afterCloseSetItem(productInfos) {
      productInfos.forEach((productInfo) => {
        let index = this.tableItems.findIndex(
          (item) => item.product_id == productInfo.product_id
        )
        // 存在しない場合のみ、荷姿情報行を追加する
        if (index == -1) {
          let addInfo = _.cloneDeep(productInfo)

          // 登録情報初期化
          addInfo.deleted = null
          addInfo.deleted_name = null
          addInfo.registration_time_display = null
          addInfo.registration_user = null
          addInfo.update_time_display = null
          addInfo.update_user = null
          addInfo.version = null
          addInfo.update_by_trigger = null

          this.tableItems.push(addInfo)
        }
      })
      this.ProductPattern.productPatternDetails = this.tableItems
    },

    setErrorMsg(msg) {
      this.$emit('set-error-msg', msg)
    },

    setWarnMsg(msg) {
      this.$emit('set-warn-msg', msg)
    },

    onRowSelected(selectedItems) {
      this.selectedItem = selectedItems
    },
    onRowClicked(item, index) {
      this.detailRowIndex = index
    },
  },
}
</script>

<style lang="scss" scoped>
.data-group-role {
  border: 1px solid #e9e9e9;
  border-radius: 4px;
  padding: 14px;
}
.edit-button {
  margin-right: 8px;
  margin-bottom: 5px;
}
</style>
